import BaseModel from '../core/BaseModel'
export default class VisitRequestModel extends BaseModel {

    constructor() {
        super({
                name: "visit_need_to_request",
                tableName: 'visit_need_to_request',
                label: "Visit Order",
                display_key: 'code'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Code'
                },
            })
    }

}